import { motion } from "framer-motion";

export default function MissionVision() {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="py-24 md:py-36 bg-brand-cream relative"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-brand-coral mb-6">
            Our mission
          </div>
          <h2 className="font-display font-black text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tighter text-brand-navy">
            Every child in the Inland Empire,
            <br />
            <span className="text-brand-coral">regardless of ability or background,</span>
            <br />
            deserves a place to thrive.
          </h2>
          <div className="mt-12 max-w-3xl mx-auto relative">
            {/* Decorative left bar with brand accent */}
            <div className="hidden md:block absolute -left-6 top-2 bottom-2 w-1.5 bg-gradient-to-b from-brand-coral via-brand-yellow to-brand-coral rounded-full" />
            <p className="text-xl md:text-2xl text-brand-navy leading-relaxed font-medium tracking-tight">
              We empower and support{" "}
              <span className="font-display font-black">all youth,</span>{" "}
              <span className="bg-brand-yellow/40 px-1.5 rounded">
                including those with disabilities
              </span>
              {" "}— cultivating a safe, nurturing environment that elevates
              the quality of life for young people and their families.{" "}
              <strong className="font-bold">Physically</strong>,{" "}
              <strong className="font-bold">Mentally</strong> and{" "}
              <strong className="font-bold">Socially</strong>.
            </p>
          </div>
        </motion.div>

        <div className="mt-16 grid grid-cols-3 gap-3 md:gap-4 text-left">
          {[
            {
              title: "Safe space",
              body:
                "An after-school environment built for structure, trust, and growth — when families need it most.",
            },
            {
              title: "Whole-child care",
              body:
                "Physical health, mental resilience, academic support, and future-readiness all under one roof.",
            },
            {
              title: "Full inclusion",
              body:
                "Adaptive fitness, sensory-friendly programming, and open arms for children of all abilities.",
            },
          ].map((v, i) => (
            <motion.div
              key={v.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              className="bg-white rounded-3xl p-4 md:p-7 border border-slate-200 min-w-0 overflow-hidden"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-brand-yellow flex items-center justify-center font-display font-black text-brand-navy text-base md:text-lg">
                {i + 1}
              </div>
              <h3 className="font-display font-bold text-base md:text-xl text-brand-navy mt-3 md:mt-5 break-words">
                {v.title}
              </h3>
              <p className="mt-2 text-xs md:text-base text-slate-600 leading-relaxed break-words hyphens-auto">
                {v.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
